import React, { Component } from 'react'

export default class Legend extends Component {
  render () {
    return (
      <div className="legend">
        {this.props.types.map(
          function (type) {
            return (
              <div key={type.type} className={type.type}>
                <div className="type_label">{type.legend}</div>
              </div>
            )
          }
        )}
      </div>
    )
  }
}
